export default "/build/images/2foot.png?ed5d63b2cde689ad1be71730efc89036";